import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton, Tooltip } from "@mui/material";
import "../batchmanagement.css";
import axios from "axios";
import { baseURL } from "../../../http";
import ManageBatchExams from "./ManageBatchExams";

function ManageBatchExamLandingPage({
  handleManageExamsClose,
  editData,
  SetDataBaseUpdate,
}) {
  const [data, setData] = useState([]);

  //--------------------------------------------------------------------------------
  // fetch the subjects from api
  //--------------------------------------------------------------------------------
  const fetchTestGenInfoname = async () => {
    try {
      const response = await axios.get(`${baseURL}/TPA_exams_getAll`);

      setData(response.data);
    } catch (error) {
      console.error("Failed to fetch test info, retrying...", error);
      fetchTestGenInfoname();
    }
  };

  //--------------------------------------------------------------------------------
  // Render call the api by using the useeffect
  //--------------------------------------------------------------------------------
  useEffect(() => {
    fetchTestGenInfoname();
  }, []);

  return (
    <>
      <div className="createtestgeneralinfoemarionsmalldiv">
        <div className="edit-icon-alignemnt">
          <Tooltip title="Back to Home" arrow>
            <IconButton onClick={handleManageExamsClose}>
              <ArrowBackIcon className="edit-icon-color-and-fontsize-generalinfo" />
            </IconButton>
          </Tooltip>
        </div>

        <div className="fontsizeandweight">
          <div className="icon-and-name-alignment-generalinfo">
            <span className="info-dispaly-font-color">
              Manage Exams-{editData.BatchName}
            </span>
          </div>
        </div>

        <div className="fontsizeandweight">
          <div className="icon-and-name-alignment-generalinfo">
            {/* <DownloadButton filteredTestData={selectedBatchTest} BatchName={editData.BatchName}/> */}
          </div>
        </div>
      </div>

      {/* ______________Manage batch subjcet api call________________ */}

      <ManageBatchExams
        SetDataBaseUpdate={SetDataBaseUpdate}
        renderRows={data}
        editData={editData}
        handleManageExamsClose={handleManageExamsClose}
      />
    </>
  );
}

export default ManageBatchExamLandingPage;
